/**
 * 6 Canonical Store Inventory & Supply Chain Reports Data Sets
 * Modeled for Construction Project Warehousing & Site Logistics in Pakistan
 */

// ── 1. Site Inventory Stock Balance & Valuation Report (Bin Card Summary) ──
export const STOCK_VALUATION_DATA = [
  {
    id: 1,
    location: "Gulberg Heights Main Store",
    itemCode: "MAT-CIV-0021",
    itemName: "OPC Cement - Bestway 50kg Bags",
    uom: "Bags",
    openingQty: 450,
    receivedQty: 2500,
    issuedQty: 1850,
    balanceQty: 1100,
    unitCost: 1420,
    totalValuation: 1562000,
    status: "Healthy",
  },
  {
    id: 2,
    location: "Gulberg Heights Main Store",
    itemCode: "MAT-STL-0105",
    itemName: "Deformed Rebar Grade-60 (Mughal Steel)",
    uom: "Tons",
    openingQty: 12.5,
    receivedQty: 45.0,
    issuedQty: 32.0,
    balanceQty: 25.5,
    unitCost: 265000,
    totalValuation: 6757500,
    status: "Healthy",
  },
  {
    id: 3,
    location: "ADF Colony Site Store",
    itemCode: "MAT-AGG-0008",
    itemName: "Chenab Coarse Sand (River Bed)",
    uom: "Cft",
    openingQty: 800,
    receivedQty: 4200,
    issuedQty: 3900,
    balanceQty: 1100,
    unitCost: 45,
    totalValuation: 49500,
    status: "Healthy",
  },
  {
    id: 4,
    location: "ADF Colony Site Store",
    itemCode: "MAT-AGG-0012",
    itemName: 'Margalla Crushed Stone (1/2" Down)',
    uom: "Cft",
    openingQty: 1200,
    receivedQty: 5000,
    issuedQty: 4600,
    balanceQty: 1600,
    unitCost: 95,
    totalValuation: 152000,
    status: "Healthy",
  },
  {
    id: 5,
    location: "Giga Mall Yard Store",
    itemCode: "MAT-BRK-0003",
    itemName: "Clay Bricks Awwal Quality (Red Kiln)",
    uom: "Nos",
    openingQty: 15000,
    receivedQty: 40000,
    issuedQty: 47000,
    balanceQty: 8000,
    unitCost: 16.5,
    totalValuation: 132000,
    status: "Low",
  },
  {
    id: 6,
    location: "River View Suites Sub-Store",
    itemCode: "MAT-PLM-0044",
    itemName: "PPRC Pipes 32mm PN20 (Popular)",
    uom: "Length (4m)",
    openingQty: 80,
    receivedQty: 350,
    issuedQty: 310,
    balanceQty: 120,
    unitCost: 1850,
    totalValuation: 222000,
    status: "Healthy",
  },
  {
    id: 7,
    location: "Gulberg Heights Main Store",
    itemCode: "MAT-ELC-0071",
    itemName: "Pakistan Cables 7/0.029 Single Core",
    uom: "Coils (90m)",
    openingQty: 25,
    receivedQty: 90,
    issuedQty: 75,
    balanceQty: 40,
    unitCost: 8900,
    totalValuation: 356000,
    status: "Healthy",
  },
  {
    id: 8,
    location: "Giga Mall Yard Store",
    itemCode: "MAT-CHM-0019",
    itemName: "Sika Plastocrete Plus Admixture",
    uom: "Litres",
    openingQty: 40,
    receivedQty: 200,
    issuedQty: 215,
    balanceQty: 25,
    unitCost: 480,
    totalValuation: 12000,
    status: "Critical",
  },
];

// ── 2. Task & BOQ Material Consumption vs. Limit Report (Reconciliation Statement) ──
export const BOQ_CONSUMPTION_DATA = [
  {
    id: 1,
    boqRef: "BOQ-CIV-002: PCC 1:4:8 Lean Concrete Foundation",
    subcontractor: "Haji Aslam & Sons",
    materialSku: "MAT-CIV-0021: OPC Cement (Bestway)",
    plannedLimit: 1450,
    cumulativeIssued: 1380,
    varianceRemaining: 70,
    status: "Within Allowance",
    uom: "Bags",
    variancePct: 95.17,
  },
  {
    id: 2,
    boqRef: "BOQ-CIV-005: RCC 1:2:4 Column Footings & Raft",
    subcontractor: "Khan Concrete Works",
    materialSku: "MAT-STL-0105: Deformed Rebar Grade-60",
    plannedLimit: 40.0,
    cumulativeIssued: 41.8,
    varianceRemaining: -1.8,
    status: "Over-Drawn Alert",
    uom: "Tons",
    variancePct: 104.5,
  },
  {
    id: 3,
    boqRef: 'BOQ-CIV-009: Brick Masonry 9" Thick Superstructure',
    subcontractor: "Bilal Steel Co. & Masonry",
    materialSku: "MAT-BRK-0003: Clay Bricks Awwal Quality",
    plannedLimit: 55000,
    cumulativeIssued: 51200,
    varianceRemaining: 3800,
    status: "Near Limit >90%",
    uom: "Nos",
    variancePct: 93.09,
  },
  {
    id: 4,
    boqRef: "BOQ-PLM-003: Sanitary Piping & Soil Stacks",
    subcontractor: "Malik Electrics & Plumbing",
    materialSku: "MAT-PLM-0044: PPRC Pipes 32mm PN20",
    plannedLimit: 350,
    cumulativeIssued: 280,
    varianceRemaining: 70,
    status: "Within Allowance",
    uom: "Lengths",
    variancePct: 80.0,
  },
  {
    id: 5,
    boqRef: "BOQ-CIV-012: Plastering 1:4 Internal & External",
    subcontractor: "Haji Aslam & Sons",
    materialSku: "MAT-AGG-0008: Chenab Coarse Sand",
    plannedLimit: 4500,
    cumulativeIssued: 4250,
    varianceRemaining: 250,
    status: "Near Limit >90%",
    uom: "Cft",
    variancePct: 94.44,
  },
  {
    id: 6,
    boqRef: "BOQ-ELC-007: Conduit Wiring & Distribution Board",
    subcontractor: "Malik Electrics & Plumbing",
    materialSku: "MAT-ELC-0071: Pakistan Cables 7/0.029",
    plannedLimit: 80,
    cumulativeIssued: 84,
    varianceRemaining: -4,
    status: "Over-Drawn Alert",
    uom: "Coils",
    variancePct: 105.0,
  },
];

// ── 3. Goods Receipt Note (GRN) Register (Inward Delivery Audit) ──
export const GRN_REGISTER_DATA = [
  {
    id: 1,
    grnNo: "GRN-2026-0098",
    deliveryDate: "2026-10-20",
    location: "Gulberg Heights Main Store",
    vendorName: "Bestway Cement Ltd",
    poNumber: "PO-2026-0098",
    vehicleBilty: "LES-9921 / Driver: Mohd Tariq",
    materialDetail: "OPC Cement (Bestway) - 1,200 Bags",
    inspectionResult: "Accepted",
    receiverName: "Shaukat Ali (Store Incharge)",
  },
  {
    id: 2,
    grnNo: "GRN-2026-0099",
    deliveryDate: "2026-10-19",
    location: "ADF Colony Site Store",
    vendorName: "Mughal Steel Co.",
    poNumber: "PO-2026-0099",
    vehicleBilty: "TK-4402 / Driver: Asif Khan",
    materialDetail: "Grade 60 Deformed Rebar - 15 Tons",
    inspectionResult: "Accepted",
    receiverName: "Rashid Mehmood (Storekeeper)",
  },
  {
    id: 3,
    grnNo: "GRN-2026-0100",
    deliveryDate: "2026-10-18",
    location: "Giga Mall Yard Store",
    vendorName: "Bilal Sand Suppliers",
    poNumber: "PO-2026-0100",
    vehicleBilty: "DRA-8120 / Driver: Sher Zaman",
    materialDetail: "Chenab Coarse Sand - 400 Cft",
    inspectionResult: "Accepted",
    receiverName: "Kashif Niaz (Site Officer)",
  },
  {
    id: 4,
    grnNo: "GRN-2026-0101",
    deliveryDate: "2026-10-17",
    location: "River View Suites Sub-Store",
    vendorName: "Popular Pipe Industries",
    poNumber: "PO-2026-0092",
    vehicleBilty: "LXZ-1108 / Driver: Tanveer Ahmed",
    materialDetail: "PPRC Pipes 32mm PN20 - 250 Nos",
    inspectionResult: "Accepted",
    receiverName: "Waqas Riaz (Store Incharge)",
  },
  {
    id: 5,
    grnNo: "GRN-2026-0102",
    deliveryDate: "2026-10-15",
    location: "Gulberg Heights Main Store",
    vendorName: "Alpha Concrete Admixtures",
    poNumber: "PO-2026-0089",
    vehicleBilty: "MN-7001 / Driver: Kamran Shah",
    materialDetail: "Superplasticizer Drums - 10 Drums",
    inspectionResult: "Rejected / Returned",
    receiverName: "Shaukat Ali (Quality Damaged)",
  },
];

// ── 4. Material Issue Register (MIN Audit Trail) ──
export const MIN_REGISTER_DATA = [
  {
    id: 1,
    minNo: "MIN-2026-0099",
    dateTime: "2026-10-21 09:30",
    workOrderRef: "WO-2026-0045 (Haji Aslam & Sons)",
    workArea: "Tower A - 3rd Floor Slab Concrete Pour",
    materialDetail: "MAT-CIV-0021: OPC Cement (Bestway)",
    qtyIssued: "180 Bags",
    issuedTo: "Mian Rafique (Foreman)",
    authorizedBy: "Engr. Salman (Site Engr)",
  },
  {
    id: 2,
    minNo: "MIN-2026-0100",
    dateTime: "2026-10-20 14:15",
    workOrderRef: "WO-2026-0048 (Khan Concrete)",
    workArea: "Basement 2 - Retaining Wall Steel Binding",
    materialDetail: "MAT-STL-0105: Rebar Grade 60 (#4 & #6)",
    qtyIssued: "4.5 Tons",
    issuedTo: "Ustad Mukhtar (Fitter Lead)",
    authorizedBy: "Engr. Farhan (RE)",
  },
  {
    id: 3,
    minNo: "MIN-2026-0101",
    dateTime: "2026-10-19 11:00",
    workOrderRef: "WO-2026-0052 (Malik Electrics)",
    workArea: "Sector J Plaza - Ground Floor Conduit Grid",
    materialDetail: "MAT-ELC-0071: Cable 7/0.029 (Red/Black)",
    qtyIssued: "12 Coils",
    issuedTo: "Imran Electrician",
    authorizedBy: "Engr. Bilal (MEP Engr)",
  },
  {
    id: 4,
    minNo: "MIN-2026-0102",
    dateTime: "2026-10-18 16:45",
    workOrderRef: "WO-2026-0058 (Bilal Steel & Masonry)",
    workArea: "Block C - External Boundary Wall Masonry",
    materialDetail: "MAT-BRK-0003: Clay Bricks Awwal",
    qtyIssued: "6,500 Nos",
    issuedTo: "Hafiz Nisar (Mason Lead)",
    authorizedBy: "Engr. Salman (Site Engr)",
  },
  {
    id: 5,
    minNo: "MIN-2026-0103",
    dateTime: "2026-10-17 10:20",
    workOrderRef: "WO-2026-0052 (Malik Electrics & Plumbing)",
    workArea: "River View Suites - 1st Floor Drainage Line",
    materialDetail: "MAT-PLM-0044: PPRC Pipes 32mm",
    qtyIssued: "45 Lengths",
    issuedTo: "Javed Plumber",
    authorizedBy: "Engr. Bilal (MEP Engr)",
  },
];

// ── 5. Inter-Site Store Transfer (TRF) & In-Transit Statement ──
export const INTER_SITE_TRANSFER_DATA = [
  {
    id: 1,
    transferId: "TRF-2026-0100",
    dispatchDate: "2026-10-18",
    dispatchStore: "Gulberg Heights Main Store",
    receivingStore: "River View Suites Sub-Store",
    materialDetail: "PPRC Pipes 32mm PN20 - 250 Nos",
    gatePassRef: "OGP-2026-0441 / Driver: Akram",
    status: "Received & Closed",
  },
  {
    id: 2,
    transferId: "TRF-2026-0101",
    dispatchDate: "2026-10-21",
    dispatchStore: "Gulberg Heights Main Store",
    receivingStore: "ADF Colony Site Store",
    materialDetail: "Deformed Steel Rebar 12mm - 5.0 Tons",
    gatePassRef: "OGP-2026-0449 / Vehicle: LWA-2019",
    status: "Dispatched / In-Transit",
  },
  {
    id: 3,
    transferId: "TRF-2026-0102",
    dispatchDate: "2026-10-14",
    dispatchStore: "Giga Mall Yard Store",
    receivingStore: "Gulberg Heights Main Store",
    materialDetail: "Surplus Clay Bricks Awwal - 10,000 Nos",
    gatePassRef: "OGP-2026-0412 / Driver: Bashir",
    status: "Received & Closed",
  },
  {
    id: 4,
    transferId: "TRF-2026-0103",
    dispatchDate: "2026-10-12",
    dispatchStore: "ADF Colony Site Store",
    receivingStore: "River View Suites Sub-Store",
    materialDetail: "Sika Admixture - 5 Drums (100 Litres)",
    gatePassRef: "OGP-2026-0398 / Carrier: TCS Logistics",
    status: "Discrepancy / Shortage",
  },
];

// ── 6. Critical Stock & Reorder Alert Report ──
export const CRITICAL_REORDER_ALERT_DATA = [
  {
    id: 1,
    materialSkuName: "MAT-CHM-0019: Sika Plastocrete Plus Admixture",
    projectSite: "Giga Mall Yard Store",
    minThreshold: 100,
    currentBalance: 25,
    shortfallQty: 75,
    dailyConsumption: "15 Litres/day",
    runwayDays: 1.6,
    actionTrigger: "Auto-Draft Requisition",
    status: "Critical",
  },
  {
    id: 2,
    materialSkuName: "MAT-BRK-0003: Clay Bricks Awwal Quality",
    projectSite: "Giga Mall Yard Store",
    minThreshold: 20000,
    currentBalance: 8000,
    shortfallQty: 12000,
    dailyConsumption: "2,500 Nos/day",
    runwayDays: 3.2,
    actionTrigger: "PO Already In-Transit",
    status: "Low",
  },
  {
    id: 3,
    materialSkuName: "MAT-CIV-0021: OPC Cement (Bestway)",
    projectSite: "River View Suites Sub-Store",
    minThreshold: 500,
    currentBalance: 120,
    shortfallQty: 380,
    dailyConsumption: "60 Bags/day",
    runwayDays: 2.0,
    actionTrigger: "Auto-Draft Requisition",
    status: "Critical",
  },
  {
    id: 4,
    materialSkuName: "MAT-STL-0105: Rebar Grade 60 (10mm)",
    projectSite: "ADF Colony Site Store",
    minThreshold: 15.0,
    currentBalance: 4.2,
    shortfallQty: 10.8,
    dailyConsumption: "1.2 Tons/day",
    runwayDays: 3.5,
    actionTrigger: "PO Already In-Transit",
    status: "Low",
  },
  {
    id: 5,
    materialSkuName: "MAT-PLM-0044: PPRC Pipe Fittings Elbow 32mm",
    projectSite: "River View Suites Sub-Store",
    minThreshold: 200,
    currentBalance: 30,
    shortfallQty: 170,
    dailyConsumption: "25 Nos/day",
    runwayDays: 1.2,
    actionTrigger: "Auto-Draft Requisition",
    status: "Critical",
  },
];
